document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('header details').forEach((details) => {
    let closeTimer;

    const openMenu = () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    };

    const closeMenu = () => {
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, 800);
    };

    details.addEventListener('mouseover', openMenu);
    details.addEventListener('mouseout', function (event) {
      if (!details.contains(event.relatedTarget)) {
        closeMenu();
      }
    });
  });
});